
import ModalV3 from "@/app/ui/components/modal/modal-v3.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { SttHangingController } from "@/app/ui/controllers/SttHangingController";
import { SubmitHangingConfirmationFollowUp, SubmitHangingConfirmationUpdateStatus } from "@/data/payload/api/HangingApiRequest";
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean
  });
  title = prop<string>({
    default: "",
    type: String
  });
  messageHtml = prop<string>({
    default: "",
    type: String
  });
  image = prop<string>({
    default: "ill_hanging_confirmation",
    type: String
  });
  textCancel = prop<string>({
    default: "",
    type: String
  });
  textSuccess = prop<string>({
    default: "",
    type: String
  });
  followUpData = prop<SubmitHangingConfirmationFollowUp>({
    required: false,
    default: new SubmitHangingConfirmationFollowUp()
  })
  statusUpdateData = prop<SubmitHangingConfirmationUpdateStatus>({
    required: false,
  })
  status = prop<string>({
    default: "Damage",
    type: String
  })
}

@Options({
  emits: ["update:modelValue", "close", "confirm"],
  components: {
    ModalV3
  }
})

class ConfirmAction extends Vue.with(Props) {

  get modalTitle() {
    return this.title || this.$t("dashboard.hanging.confirmDoneTitle");
  }

  get modalMessageHtml() {
    return this.messageHtml || this.$t("dashboard.hanging.confirmDoneMessage");
  }

  get modalTextCancel() {
    return this.textCancel || this.$t("dashboard.hanging.cancel");
  }

  get modalTextSuccess() {
    return this.textSuccess || this.$t("dashboard.hanging.confirmDoneSuccess");
  }

  async onConfirm() {
    this.$emit("confirm");
  }

  onCloseModal() {
    this.$emit("update:modelValue", false);
  }
}
export default ConfirmAction;
